module.exports = __webpack_public_path__ + "static/media/cw.ae75cba5.svg";